export const OrderType = {
  ASAP: 'ASAP',
  FUTURE: 'FUTURE'
};
